"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_cloud__download(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad2b20b2-9d8c-463d-9fac-6ad57058b238",
    x1: 87.28,
    y1: 87.62,
    x2: 134.63,
    y2: 134.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "cloud-download-hi"), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "a079717f-5110-49f8-acbc-5a00623d4a82",
    "data-name": "cloud-download-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "50c72984-8bae-4d12-b41e-f1ce681b535c",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cd0920b4-bb5f-4883-ad0a-b140d03c23b9",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6e7e1284-6006-468b-b6f3-2105ff690e1f",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "34c7a6c0-0bb9-4243-ac04-2bc4bcb3086a",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8c1a2767-5a99-4269-93e8-180974d15a27",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e69707c2-d600-45f8-8f03-3d4937235e38",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0a93af2c-274c-43d4-8e01-65d909407119",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "57581f71-2c32-4cd7-b0a9-ab2c451ec359",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "93647da1-1aaf-457f-9809-f866113fcd5c",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b4419546-f244-4312-9a59-802c3f4c26cc",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b2afa249-f809-4fd9-8768-04715841f5e8",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3f1ae383-ca4c-4446-be56-136cb223580f",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5e3ca6b8-388b-42d5-8246-e44e668a2421",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5a0c90af-d92e-45c7-8c2e-32b7f2b3c43e",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1c25ebf7-4cf3-498d-b856-fc2be52e177e",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "112bc201-6fe5-4fd0-b189-19e4e8013adf",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dedc51c3-fbec-4199-90d3-d6be72d79995",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f10f32de-4cda-4c23-978c-b71dd4483504",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f8b0b821-0d68-497a-a777-8d71b79f9363",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2d347a56-1c47-4b6d-b6d5-3ffce9bb8bb4",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6df0577f-59fd-4702-849f-7cfbaa4a174f",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b121ed8a-54d0-4a7a-84db-f641c6894da0",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7954e11d-0e51-4af7-9376-70c593e6c4e6",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "56595f41-8804-4844-896a-45f6ae8c8694",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1a7fbebf-f66b-4101-a1c3-cafc4e8d8999",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "360d47b2-0ecb-4eac-8aa5-202f24209174",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eb177d4b-0112-489d-9ea7-9437dc8e97b9",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "261b76d3-fcaf-412d-b58e-48e9181cefa6",
    "data-name": "Cloud_download_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,85.25a38.91,38.91,0,0,0-48.64-37.51A45.17,45.17,0,0,0,39.3,56.46,34.74,34.74,0,0,0,50.86,124h86.52A38.81,38.81,0,0,0,176,85.25Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.38,122H50.86A34.8,34.8,0,0,1,16,88.13c0,.37,0,.74,0,1.12A34.8,34.8,0,0,0,50.86,124h86.52A38.81,38.81,0,0,0,176,85.25c0-.33,0-.67,0-1A38.8,38.8,0,0,1,137.38,122Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.39,75.5,99.28,124h38.1a39,39,0,0,0,9.44-1.22Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#ad2b20b2-9d8c-463d-9fac-6ad57058b238)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.99,
    y1: 78.5,
    x2: 96.99,
    y2: 172.02,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "122.99 144.02 96.99 172.02 70.99 144.02",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.92,144.74l-26,28a4,4,0,0,1-5.86,0l-26-28a4,4,0,0,1-.93-1.74,4,4,0,0,0,.93,3.74l26,28a4,4,0,0,0,5.86,0l26-28a4,4,0,0,0,.93-3.74A4,4,0,0,1,125.92,144.74Z",
    transform: "translate(0 0)",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }))))))))))))))))))))))))))))))));
}

var _default = ic_cloud__download;
exports.default = _default;